import { Injectable } from '@angular/core';
import { ApiService, UtilService, PagedSearch, PagedResult } from '../../../shared/index';
import { IEventPromoCodesService } from './ievent-promo-codes.service';
import { EventPromoCode } from './event-promo-code.model';
import { TranslationService } from '../../../shared/translation/translation.service';

@Injectable()
export class EventPromoCodesService implements IEventPromoCodesService {
  public _apiService: ApiService;
  public _utilService: UtilService;
  public _translationService: TranslationService;

  public constructor(apiService: ApiService, utilService: UtilService) {
    this._apiService = apiService;
    this._utilService = utilService;
  }

  public getEventPromoCodes = (eventId: number): Promise<Array<EventPromoCode>> => {
    let url: string = 'Event/' + eventId.toString() + '/PromoCodes?PageSize=9999';
    return this._apiService.get(url);
  };

  public getEventPromoCode = (promoCodeId: number): Promise<EventPromoCode> => {
    let url: string = 'PromoCode/' + promoCodeId.toString();
    return this._apiService.get(url);
  };

  public upsertEventPromoCode = (eventPromoCode: EventPromoCode): Promise<any> => {
    if (eventPromoCode.PromoCodeId > 0) {
      let url: string = 'PromoCode/' + eventPromoCode.PromoCodeId;
      return this._apiService.put(url, eventPromoCode);
    } else {
      let url: string = 'PromoCodes';
      return this._apiService.post(url, eventPromoCode).then((data: any) => {
        eventPromoCode.PromoCodeId = data;
      });
    }
  };

  public deleteEventPromoCode = (promoCodeId: number): Promise<any> => {
    return this._apiService.delete('PromoCode/' + promoCodeId);
  };

  public exportPromoCodes = (eventId: number): Promise<string> => {
    let url = 'Event/' + eventId.toString() + '/PromoCodes/Export';
    return this._apiService.get(url);
  };

  public exportPromoCode = (eventId: number, promoCodeId: number): Promise<string> => {
    let url = 'PromoCode/' + eventId.toString() + '/' + promoCodeId.toString() + '/Export';
    return this._apiService.get(url);
  };
}
